<template>
  <div id="app">
    <router-view />
    <GlobalSearch ref="globalSearchRef" />
  </div>
</template>

<script>
import NavHeader from "@/components/NavHeader/index.vue";
import GlobalSearch from "@/components/GlobalSearch/index.vue";

export default {
  name: "App",
  components: {
    NavHeader,
    GlobalSearch,
  },
  mounted() {
    this.registerSearchShortcut();
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    registerSearchShortcut() {
      this.handleKeydown = (e) => {
        // Cmd+K (Mac) 或 Ctrl+K (Windows) 打开全局搜索
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.$refs.globalSearchRef.open();
        }
      };
      document.addEventListener("keydown", this.handleKeydown);
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
</style>
